/* src/app/user-default/content/content.component.scss */
.card-detail {
  margin: 0 20px;
  max-width: 42rem;
  padding-top: 0px;
}
a,
a:hover,
a:focus {
  color: inherit;
  transition: all 0.3s;
  text-decoration: underline;
}
/*# sourceMappingURL=content.component-KO4RO6YF.css.map */
